module.exports = __webpack_public_path__ + "img/2_1.7f9e97e8.png";